module.exports = __webpack_public_path__ + "img/p39.3266709f.png";